module.exports = __webpack_public_path__ + "img/entry-configurator.a2593cbd.svg";